import { Link, useLocation } from "@tanstack/react-router"
import { RadarIcon, Shield, Plane, User, MoreHorizontal } from "lucide-react"
import { useSidebar } from "@uavity-core/ui/components/sidebar"
import { cn } from "@uavity-core/ui/lib/utils"
import { pathMatches } from "@/components/nav-main"

const tabs = [
  { title: "Flight Zones", url: "/flight-restriction-zones", icon: Shield },
  { title: "Flight Plans", url: "/flight-plans", icon: Plane },
  { title: "Live Map", url: "/", icon: RadarIcon },
  { title: "Account", url: "/account", icon: User },
] as const

export function BottomNav() {
  const { pathname } = useLocation()
  const { toggleSidebar } = useSidebar()

  const onOverflowRoute = pathname !== "/map" && !pathname.startsWith("/flight-plan/") && !tabs.some((tab) => pathMatches(pathname, tab.url))

  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-30 flex h-[calc(4rem+env(safe-area-inset-bottom))] items-stretch border-t border-border/60 bg-card/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-sm md:hidden"
    >
      {tabs.map((tab) => {
        const active = tab.url === "/" ? pathname === "/" || pathname === "/map" : tab.url === "/flight-plans" ? pathname.startsWith("/flight-plans") || pathname.startsWith("/flight-plan/") : pathMatches(pathname, tab.url)
        return (
          <Link
            key={tab.url}
            to={tab.url}
            aria-current={active ? "page" : undefined}
            className={cn(
              "flex flex-1 flex-col items-center justify-center gap-1 px-1 text-[0.7rem] font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary",
              active ? "bg-primary/10 font-semibold text-primary" : "text-muted-foreground"
            )}
          >
            <tab.icon className="h-5 w-5" aria-hidden />
            {tab.title}
          </Link>
        )
      })}
      <button
        type="button"
        onClick={toggleSidebar}
        aria-current={onOverflowRoute ? "page" : undefined}
        className={cn(
          "flex flex-1 flex-col items-center justify-center gap-1 px-1 text-[0.7rem] font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary",
          onOverflowRoute ? "text-primary" : "text-muted-foreground"
        )}
      >
        <MoreHorizontal className="h-5 w-5" aria-hidden />
        More
      </button>
    </nav>
  )
}
